import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "./style.scss";

// reactstrap imports
import {
  Card, CardImg, CardColumns, CardBody, Row, Col, Spinner
} from 'reactstrap';

// call actions
import { getGames, getRandomGames } from "../../actions/games.action";

class ConnectedHomeContent extends Component {

  componentDidMount() {
    this.props.getGames();
    this.props.getRandomGames();
  }

  render() {
    const { games, twoGames, isLoading } = this.props;

    return (
      <div className="Content-container">
        <div className="Content-title">
          <div className="title">
            populaires et recommandés
                    </div>
          <div className="title-see-more">
            Voir tout
                        <img src="https://res.cloudinary.com/djrdn2vgg/image/upload/v1590151863/SteamProject/blue_right_arrow_ly5bqw.png" alt="blue-right-arrow" className="blue-right-arrow" />
          </div>
        </div>
        <div className="cards-container">
          <CardColumns>
            {
              isLoading === true ? (
                games.map(game => (
                  <Card key={game.id} className="card-loading-container">
                    <Spinner color="light" className="card-loading-spinner" />
                  </Card>
                ))
              )
                :
                games.length > 0 ?
                  games.map(game => (
                    <Card key={game.id}>
                      <Link to={`/product/${game.id}`} className="link">
                        <div className="img-hover-zoom">
                          <CardImg top width="100%" src={game.jaquette} alt="Card-Jaquette" />
                        </div>
                        <CardBody>
                          <div className="text-genre">
                            {game.genre}
                          </div>
                          <div className="text-price">
                            {game.price + '€'}
                          </div>
                        </CardBody>
                      </Link>
                    </Card>
                  ))
                  :
                  <div>Une erreur est survenue, nous tentons de régler ce problème le plus vite possible !</div>
            }
          </CardColumns>
        </div>
        <div className="Content-banner">
          <div className="banner-title">
            Livraison Gratuite Mondiale
                    </div>
          <div className="banner-text">
            sur commandes de plus de 50 € jusqu'à minuit (GMT) Mercredi 19 Septembre
                    </div>
          <div className="banner-see-more">
            Voir plus
                        <img src="https://res.cloudinary.com/djrdn2vgg/image/upload/v1590591349/SteamProject/small_grey_arrow_qf4emy.png" alt="blue-right-arrow" className="blue-right-arrow" />
          </div>
        </div>
        <div className="Content-title">
          <div className="title">
            offres spéciales
                    </div>
          <div className="title-see-more">
            Voir tout
                        <img src="https://res.cloudinary.com/djrdn2vgg/image/upload/v1590151863/SteamProject/blue_right_arrow_ly5bqw.png" alt="blue-right-arrow" className="blue-right-arrow" />
          </div>
        </div>
        <div>
          <Row>
            {
              isLoading === true ? (
                <Card className="card-loading-container">
                  <Spinner color="light" className="card-loading-spinner" />
                </Card>
              )
                :
                twoGames.length > 0 ?
                  twoGames.map(twoGame => (
                    <Col sm="6" key={twoGame.id}>
                      <Card className="promo-card">
                        <Link to={`/product/${twoGame.id}`} className="link">
                          <div className="img-hover-zoom">
                            <CardImg top width="100%" src={twoGame.jaquette} alt="Card-Jaquette" className="card-img-promo" />
                          </div>
                        </Link>
                        {
                          twoGame.promo === true ?
                            <div className="discount-container">
                              - {twoGame.promorate} %
                                                </div>
                            :
                            null
                        }
                        {
                          twoGame.description !== null ?
                            <CardBody>
                              <div className="text-description">
                                {twoGame.description}
                              </div>
                            </CardBody>
                            :
                            null
                        }
                      </Card>
                    </Col>
                  ))
                  :
                  <div>Une erreur est survenue, nous tentons de régler ce problème le plus vite possible !</div>
            }
          </Row>
        </div>
      </div >
    );
  }
}

const mstp = state => {
  return {
    games: state.gameInfo.game,
    twoGames: state.gameInfo.twoRandomGames,
    isLoading: state.gameInfo.isLoading
  };
};

const mdtp = dispatch => ({
  getGames: () => dispatch(getGames()),
  getRandomGames: () => dispatch(getRandomGames())
});

const HomeContent = connect(
  mstp,
  mdtp
)(ConnectedHomeContent);

export default HomeContent;